import { Handedness } from "../types"
import '@/utils/math/conversions'

/**
 * 
 * @param heightFeet 
 * @param armTiltDeg 
 * @param handedness 
 * @returns release point in ft
 */
export const getReleasePoint = (heightFeet: number, armTiltDeg: number, handedness: Handedness): {x:number, z:number} => {
  const moundHeight = 10 / 12 // mound is 10in above home plate
  const legLength = heightFeet * .5925
  const torsoLength = heightFeet * .3
  const armLength = heightFeet * .3865
  if (handedness == 'rh') {
      const torsoLengthX = Math.sin(-1 * (90 - armTiltDeg).toRadians()) * torsoLength
      const torsoLengthY = Math.cos(-1 * (90 - armTiltDeg).toRadians()) * torsoLength
      const armLengthX = Math.sin(armTiltDeg.toRadians()) * armLength
      const armLengthY = Math.cos(armTiltDeg.toRadians()) * armLength
      return {x: torsoLengthX + armLengthX, z: legLength + torsoLengthY + armLengthY + moundHeight}
    } else {
        const armLengthX = Math.sin(-1 * (360 - armTiltDeg).toRadians()) * armLength
      const armLengthY = Math.cos(-1 * (360 - armTiltDeg).toRadians()) * armLength
      const torsoLengthX = Math.sin((90 - 360 - armTiltDeg).toRadians()) * torsoLength
      const torsoLengthY = -Math.cos((90 - 360 - armTiltDeg).toRadians()) * torsoLength
      return {x: torsoLengthX + armLengthX, z: legLength + torsoLengthY + armLengthY + moundHeight}
    }

}
